/**
 * Trigger: tr_incomes_insert
 * Purpose: Update account balances and daily balances when an income is inserted
 * Table: incomes
 * Event: AFTER INSERT
 */
export const TR_INCOMES_INSERT = `
CREATE TRIGGER tr_incomes_insert
AFTER INSERT ON incomes
FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET incomes_amount = incomes_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.income_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.income_date);

  UPDATE account_daily_balances
  SET incomes_amount = incomes_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.income_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.income_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
